/**
 * Diagnostic Realtime (canal + postgres_changes).
 * - Actif en dev (`npm run dev`), ou si `VITE_SUPABASE_REALTIME_DEBUG=true` dans `.env`.
 * - En navigateur : `window.__autodjRealtimeRx` (compteurs + dernier événement).
 */

export function isRealtimeDebugEnabled() {
  try {
    return (
      Boolean(import.meta.env?.DEV) ||
      String(import.meta.env?.VITE_SUPABASE_REALTIME_DEBUG ?? '').toLowerCase() === 'true'
    );
  } catch {
    return false;
  }
}

export function rtDebug(label, detail) {
  if (!isRealtimeDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.info(`[realtime] ${label}`, detail === undefined ? '' : detail);
}

/** Compte les postgres_changes reçus (utile pour vérifier que le filtre / la réplication marchent). */
export function bumpRealtimeRx(table, eventType) {
  if (!isRealtimeDebugEnabled() || typeof window === 'undefined') return;
  if (!window.__autodjRealtimeRx) {
    window.__autodjRealtimeRx = { byTable: {}, last: null, since: Date.now() };
  }
  const rx = window.__autodjRealtimeRx;
  rx.byTable[table] = (rx.byTable[table] ?? 0) + 1;
  rx.last = { table, eventType, at: Date.now() };
}
